/**
 * この関数はISO形式の日付文字列を受け取り、フォーマットされた日付文字列を返します。
 * YYYY-mm-dd HH:MM
 * @param isoDateString
 * @returns
 */
export function formatDatetime(isoDateString: string): string {
  const date = new Date(isoDateString);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * この関数はISO形式の日付文字列を受け取り、フォーマットされた日付文字列を返します。
 * YYYY-mm-dd
 * @param isoDateString
 * @returns
 */
export function formatDate(isoDateString: string): string {
  const date = new Date(isoDateString);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
}

/**
 * この関数はISO形式の日付文字列を受け取り、フォーマットされた日付文字列を返します。
 * YYYY-mm-dd
 * @param isoDateString
 * @returns
 */
export function formatDate2(isoDateString: string): string {
  const date = new Date(isoDateString);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${year}/${month}/${day}`;
}

/**
 * Dateを受け取り、フォーマットされた年月文字列を返します。
 * @param date
 * @returns YYYYmm
 */
export function formatYYYYmm(date: Date): string {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  return `${year}${month}`;
}

/**
 * Dateを受け取り、フォーマットされた年月文字列を返します。
 * @param date
 * @returns YYYY年MM月
 */
export function formatYearMonthJp(date: Date): string {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  return `${year}年${month}月`;
}

/**
 * Dateを受け取り、フォーマットされた年月文字列を返します。
 * @param date
 * @returns YYYY-MM
 */
export function formatYYYYmmWithHyphen(date: Date): string {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  return `${year}-${month}`;
}

/**
 * Dateを受け取り、フォーマットされた年月文字列を返します。
 * @param date
 * @returns YYYY-MM-DD
 */
export function formatYYYYmmddWithHyphen(date: Date): string {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
}

/**
 * 現在の日本時刻(UTC+9時間)を返却する関数
 * @returns {Date} 日本時刻
 */
export function getCurrentJapanTime(): Date {
  const currentUTC = new Date();
  // Japan is UTC+9
  const japanTime = new Date(currentUTC.getTime() + 9 * 60 * 60 * 1000);
  return japanTime;
}

/**
 * 基準日を含めて指定日数後の日付を取得
 * @param days 日数
 * @returns 日付文字列
 */
export function getDateAfterDays(baseDate: Date, days: number): string {
  baseDate.setDate(baseDate.getDate() + days - 1);
  return formatDate2(baseDate.toISOString());
}

/**
 * ISO形式の日付文字列を日本語ローカライズで「YYYY/MM/DD HH:mm」形式にフォーマット
 * @param isoDateString
 * @returns 例: 2025/07/15 10:17
 */
export function formatSavedAtJp(isoDateString: string): string {
  try {
    const date = new Date(isoDateString);
    return date
      .toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      })
      .replace(/\//g, '/');
  } catch {
    return isoDateString;
  }
}
